module.exports = __webpack_public_path__ + "static/media/sold_to_offerpad.b5278cd7.svg";